import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { CreateOrganizationInvitationForm } from '~/components/forms/OrganizationInvitationForm';
import { Heading } from '~/components/molecules/Heading';
import { useNavigate } from '~/components/utils/Navigation';

export type IOrganizationCreateInvitationPageProps = {
  organizationId: string;
  previousUrl?: string;
  nextUrl?: string;
  cancelUrl?: string;
};

export const OrganizationCreateInvitationPage: React.FC<
  IOrganizationCreateInvitationPageProps
> = (props) => {
  const { organizationId, previousUrl, nextUrl, cancelUrl } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('OrganizationCreateInvitationPage.seo.title')}</title>
      </Helmet>

      <Heading
        title={t('OrganizationCreateInvitationPage.title')}
        previousUrl={previousUrl ?? `/organizations/${organizationId}/users`}
      />

      <CreateOrganizationInvitationForm
        onSuccess={() =>
          navigate(nextUrl ?? `/organizations/${organizationId}/invitations`)
        }
        cancelUrl={cancelUrl ?? `/organizations/${organizationId}/users`}
        defaultValues={{
          organizationId,
        }}
      />
    </>
  );
};
